@if (entry()) {
    <aside>
        @if (entry().type === 'chat') {
            <div class="m-5 rounded-lg bg-white shadow-lg">
                <div class="grid grid-cols-12 p-4 md:p-8">
                    <div
                        class="col-span-12 mb-4 flex justify-center text-center md:col-span-3 md:mb-0">
                        <div class="grid w-full grid-cols-3 md:grid-cols-1">
                            <div
                                class="col-span-2 flex justify-end md:col-span-1 md:justify-center">
                                <div class="relative w-24">
                                    <div class="aspect-h-1 aspect-w-1 w-full">
                                        <app-lazy-asset
                                            [configuration]="
                                                featuredImageConfigurationChat()
                                            "
                                            [additionalClasses]="[
                                                'rounded-full',
                                            ]">
                                        </app-lazy-asset>
                                        <div
                                            class="absolute h-full w-full origin-center rotate-45 transform">
                                            <div
                                                class="absolute -right-2 top-1/2 h-4 w-4 rounded-full border-2 border-white bg-green"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div
                                class="col-span-1 flex items-center justify-center md:hidden">
                                <app-lazy-asset
                                    [configuration]="dialogBubbleImage">
                                </app-lazy-asset>
                            </div>
                        </div>
                    </div>
                    <div
                        class="col-span-12 flex flex-col justify-start text-center md:col-span-6 md:px-6 md:text-left">
                        <h3 class="font-heading text-xl font-semibold">
                            {{ entry().title }}
                        </h3>
                        <p class="pb-4 font-serif text-lg">
                            {{ entry().description }}
                        </p>
                        <app-cta-button
                            (onClick)="openChat()"
                            type="button"
                            [additionalClasses]="['md:mx-0']">
                            Chat Now
                        </app-cta-button>
                    </div>
                    <div
                        class="col-span-12 hidden justify-center md:col-span-3 md:flex">
                        <app-lazy-asset [configuration]="dialogBubbleImage">
                        </app-lazy-asset>
                    </div>
                </div>
            </div>
        }
        @if (entry().type === 'url') {
            <div class="m-5 rounded-lg bg-white shadow-lg">
                <div class="grid grid-cols-12">
                    <div
                        class="order-2 col-span-12 p-8 md:order-1 md:col-span-6">
                        <h3 class="font-heading text-xl font-[600]">
                            {{ entry().title }}
                        </h3>
                        <p class="pb-4 font-serif text-lg text-darkgrey">
                            {{ entry().description }}
                        </p>
                        <app-cta-button
                            [link]="[entry().url]"
                            type="link"
                            [additionalClasses]="['mx-0']">
                            View Trip
                        </app-cta-button>
                    </div>
                    <div class="order-1 col-span-12 md:order-2 md:col-span-6">
                        <div
                            class="aspect-h-12 aspect-w-16 w-full md:aspect-w-4 lg:aspect-w-6 xl:aspect-w-9 2xl:aspect-w-16">
                            <app-lazy-picture
                                [configurations]="
                                    featuredImageConfigurationLink()
                                "
                                [additionalClasses]="[
                                    'rounded-tl-lg rounded-tr-lg md:rounded-br-lg md:rounded-tl-none',
                                ]"></app-lazy-picture>
                        </div>
                    </div>
                </div>
            </div>
        }
    </aside>
}
